<template>
  <Loader
    :value="promises.fetchOne"
    :message="$t('loading', { resource: $tc('project', 2) }) + '...'"
    class="project-openhouse"
  >
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title" :breadcrumb="breadcrumb">
        <template #actions>
          <ButtonComponent
            :tag="createDisabledMessage ? 'div' : 'router-link'"
            :label="$t('create')"
            theme="primary"
            :to="{
              name: 'project-openhouse-create',
              params: { project: id },
              query: { returnTo: $route.path },
            }"
            :class="{ 'elder-button--disabled': createDisabledMessage }"
            :icon="['fal', 'plus']"
            v-tooltip="createDisabledMessage"
          />
        </template>
      </HeaderComponent>
      <DataTable
        v-if="items.length || states.fetch"
        sticky="var(--header-height)"
        :value="items"
        :columns="[
          { id: 'date', label: $t('date') },
          { id: 'from', label: `${$t('from')} - ${$t('to')}` },
          { id: 'message', label: $tc('message') },
          { id: 'references', label: $t('openhouseReferences') + '?' },
        ]"
        :row-wrapper="
          item => ({
            component: createDisabledMessage ? 'div' : 'router-link',
            props: {
              to: { name: 'project-openhouse-edit', params: { id: item.id, project: id } },
              style: 'color: inherit',
            },
          })
        "
        v-tooltip="createDisabledMessage"
      >
        <template #date="{ item }">{{ item.from | Moment('DD.MM.YYYY') }}</template>
        <template #from="{ item }">{{ item.from | Moment('HH.mm') }} - {{ item.to | Moment('HH.mm') }}</template>
        <template #message="{ item }">{{ item.message }}</template>
        <template #references="{ item }">{{ getReferences(item) }}</template>
      </DataTable>
      <EmptyState
        v-else-if="!errors.fetchOne"
        :title="$t('noX', { x: this.$tc('openhouse', 2).toLowerCase() })"
        :subtitle="$t('openhouseEmptyState')"
        :icon="['fal', 'sign']"
        action-portal
      />
    </div>
  </Loader>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Moment } from '@/filters'

import HeaderComponent from '@/components/Header'
import EmptyState from '@/components/EmptyState'
import DataTable from '@/components/DataTable'

export default {
  props: {
    id: String,
  },
  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  computed: {
    ...mapState('Project', ['item', 'promises', 'states', 'errors']),
    breadcrumb() {
      return [
        { title: this.$tc('project', 2), action: { name: 'projects' } },
        {
          title: this.item.name,
          action: { name: 'project-dashboard', params: { id: this.id } },
        },
        { title: this.$metaInfo.title },
      ]
    },
    items() {
      return this.$path('item.openhouses') || []
    },
    createDisabledMessage() {
      return (
        this.$path('item.metadata.disabledFields.project.openhouses') ||
        this.$path('item.metadata.disabledFields.unit.openhouses')
      )
    },
  },
  methods: {
    ...mapActions('Project', {
      fetch(dispatch) {
        return dispatch('fetch', [{ id: this.id }, { query: 'ProjectOpenhouses' }]).then(() => {
          if (!this.item.id) return this.$router.push({ name: 'notfound' })
        })
      },
    }),
    getReferences(item) {
      let residentials = item.references.map(r => r.number)
      if (!residentials.length) return this.$t('theWholeProject')

      return `${this.$tc('residential', residentials.length)} ${residentials.join(', ')}`
    },
  },
  metaInfo() {
    return {
      title: this.$tc('openhouse', 2),
    }
  },
  components: {
    HeaderComponent,
    EmptyState,
    DataTable,
  },
  filters: {
    Moment,
  },
}
</script>

<style lang="scss">
.project-openhouse {
  background-color: $background-grey;
}
</style>
